<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">员工</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>员工列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create @refresh="getProjectList"></create>
        <get-staff-amount @refresh="getProjectList"></get-staff-amount>
        <every-day></every-day>
      </div>
      <list @refresh="getProjectList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import Create from './components/create';
import List from './components/list';
import baseConfig from './components/baseConfig';
import SetPercent from './components/setpercent';
import SearchAmount from './components/searchAmount';
import GetStaffAmount from './components/getStaffAmount';
import EveryDay from './components/everday';

export default {
  name: 'kpiProject',
  data() {
    return {
      options: [
        {
          value: '1',
          label: '邀请额度'
        },
        {
          value: '2',
          label: 'USDT额度'
        },
        {
          value: '3',
          label: 'FBS额度'
        },
        {
          value: '4',
          label: '全部额度'
        }
      ],
      updated: ''
    };
  },
  components: {
    List,
    Create,
    GetStaffAmount,
    EveryDay
    // baseConfig,
    // SetPercent,
    // SearchAmount
  },
  computed: {
    ...mapState('kpiProject', ['pagination'])
  },
  methods: {
    ...mapActions('kpiProject', [
      'getList',
      'getCoinTypeList',
      'freshData',
      'getIdamount'
    ]),
    getProjectList(data = {}) {
      this.getList({
        ...this.pagination,
        ...data
      });
    },
    update() {
      this.freshData({ target: this.updated }).then(() => {
        this.updated = '';
      });
    }
  },
  created() {
    this.getProjectList();
    this.getCoinTypeList();
    // this.getIdamount({...this.pagination});
  }
};
</script>
<style lang="less" scoped>
.change {
  ::v-deep .el-button {
    margin-left: 20px;
  }
}
</style>
